import {
  EventSearchResult,
  PostSearchResult,
  ProductSearchResult,
  SearchResult,
} from '@planone/bau365/data-access-search';
import { ExhibitorSearchResult } from '@planone/bau365/data-access-search';
import { EntityType, Event, Exhibitor, ExhibitorCardData, Post, Product } from '@planone/bau365/util-fair-data';

import { of } from 'rxjs';

import {
  NewsfeedEvent,
  NewsfeedExhibitor,
  NewsfeedPost,
  NewsfeedProduct,
  NewsfeedResult,
} from '../state/newsfeed-results/newsfeed-results.models';

export function mapSearchToNewsfeedResult(result: SearchResult, lastVisitedAt?: Date): NewsfeedResult {
  switch (result.type) {
    case 'EXHIBITOR':
      return mapExhibitorToNewsfeedResult(result, lastVisitedAt);
    case 'PRODUCT':
      return mapProductToNewsfeedResult(result, lastVisitedAt);
    case 'POST':
      return mapPostToNewsfeedResult(result, lastVisitedAt);
    case 'EVENT':
      return mapEventToNewsfeedResult(result, lastVisitedAt);
  }
}

function mapExhibitorToNewsfeedResult(exhibitor: ExhibitorSearchResult, lastVisitedAt?: Date): NewsfeedExhibitor {
  return {
    ...exhibitor,
    type: EntityType.exhibitor,
    last_visited_at: lastVisitedAt,
    is_highlighted: false,
    is_startup: exhibitor.flags?.includes('STARTUP'),
    logo: { ...exhibitor.image, description: '' },
    exhibition_halls:
      exhibitor.booth && exhibitor.booth.id && exhibitor.booth.fair_id
        ? [
            {
              id: exhibitor.booth.id,
              fair_id: exhibitor.booth.fair_id,
              name: exhibitor.booth.hall_name,
              booths: [{ name: exhibitor.booth.name }],
            },
          ]
        : [],
  };
}

function mapProductToNewsfeedResult(product: ProductSearchResult, lastVisitedAt?: Date): NewsfeedProduct {
  return {
    ...product,
    type: EntityType.product,
    exhibitor: extractExhibitorInfo(product),
    is_highlighted: false,
    last_visited_at: lastVisitedAt,
    images: [{ ...product.image, description: '' }],
  };
}

function mapPostToNewsfeedResult(post: PostSearchResult, lastVisitedAt?: Date): NewsfeedPost {
  return {
    ...post,
    type: EntityType.post,
    exhibitor: extractExhibitorInfo(post),
    last_visited_at: lastVisitedAt,
    headline: post.name,
    hero_image: { ...post.image, description: '' },
    summary: post.short_description,
    content: post.name,
  };
}

function mapEventToNewsfeedResult(event: EventSearchResult, lastVisitedAt?: Date): NewsfeedEvent {
  return {
    ...event,
    type: EntityType.event,
    exhibitor: extractExhibitorInfo(event),
    last_visited_at: lastVisitedAt,
    headline: event.name,
    starts_at: event.starts_at.toISOString(),
    ends_at: event.ends_at.toISOString(),
  };
}

function extractExhibitorInfo(item: ProductSearchResult | EventSearchResult | PostSearchResult): ExhibitorCardData {
  return {
    id: item.exhibitor_id ?? '',
    name: item.exhibitor_name ?? '',
    mood_image: { ...item.image, description: '' },
    ...(item.type === 'PRODUCT' ? { address: item.exhibitor_address } : {}),
    fair_id: item.fair_id,
  };
}

export function mapUserHistoryExhibitor(exhibitor: Exhibitor): NewsfeedExhibitor {
  return { ...exhibitor, top_of_the_list: false, type: EntityType.exhibitor };
}

export function mapUserHistoryPost(post: Post, exhibitor: Exhibitor): NewsfeedPost {
  return { ...post, type: EntityType.post, exhibitor, published_at: new Date(post.published_at) };
}

export function mapUserHistoryProduct(product: Product, exhibitor: Exhibitor): NewsfeedProduct {
  return {
    ...product,
    exhibitor,
    type: EntityType.product,
    published_at: product.published_at ? new Date(product.published_at) : undefined,
  };
}

export function mapUserHistoryEvent(event: Event, exhibitor: Exhibitor): NewsfeedEvent {
  return {
    ...event,
    exhibitor,
    type: EntityType.event,
  };
}

export function processError(_error: { status: number }) {
  // if (error.status === 404) {
  return of(undefined);
  // } else throw error;
}
